'use client';
import ProductCard from '@/components/productCard';
import { pxToVw } from '@/components/productCard/common/utils';
import { ProductType } from '@/components/productCard/index.interface';
import { useStores } from '@/models';
import { getExposureRecord, sendClickTrack } from '../../../tempo_track';
import style from './productList.module.scss';
interface ListProps {
  skuList: any;
  paramsData: any;
  pos: number;
  pageCode: string;
  moduleInstanceId: string;
  localInfo: any;
}
const adaptiveStyle = {
  productCardWidth: pxToVw(120),
  skuImgWidth: pxToVw(120),
  skuImgHeight: pxToVw(120),
  cartIconWidth: pxToVw(24),
  cartIconHeight: pxToVw(24),
  productListGap: pxToVw(12),
  productListPaddingLeft: pxToVw(8),
  containerPaddingTop: pxToVw(12),
};
export const ProductList = ({
  skuList,
  paramsData,
  pos,
  pageCode,
  localInfo,
  moduleInstanceId,
}: ListProps) => {
  const { cartNumStore } = useStores();
  let productList = [];

  const exposureRecord = getExposureRecord(pageCode);
  if (skuList && skuList.length > 0) {
    if (skuList.length > 20) {
      productList = skuList.slice(0, 20);
    } else {
      productList = skuList;
    }
  }
  const getCartNum = () => {
    cartNumStore.fetchCartNum(true);
  };
  //------------------------ 商品&加购 点击和曝光 埋点 -------------------------

  const genJsonParam = (product: any, index: number) => {
    const json_param: any = {
      page_id: pageCode,
      moduleInstanceId: moduleInstanceId,
      pos: pos,
      index: index,
      skuid: isNaN(product?.skuId) ? '-100' : product.skuId.toString(),
      propoolid: paramsData?.productPoolId,
    };
    return json_param;
  };

  const genEventTrackingInfo = (product: any, index: number) => {
    const eventTrackingInfo = {} as { [key: string]: any };
    const json_param = genJsonParam(product, index);
    const expConfig = {
      useClick: false,
      stay_duration: 0.3,
      repeated: false,
      area_rate: 0.5,
    };
    if (product.algoRdInfo) {
      json_param.propoolid = product.productPoolId;
      json_param.broker_info = product.brokerInfo ? JSON.stringify(product.brokerInfo) : '';
      json_param.algo_rd_inf = product.algoRdInfo;
    }

    eventTrackingInfo['productClickPoint'] = () =>
      sendClickTrack.cms_TempoPage_HorizontalProductPool_click(json_param);
    eventTrackingInfo['cartClickPoint'] = () =>
      sendClickTrack.cms_TempoPage_HorizontalProductPool_addtocart_click(json_param);
    eventTrackingInfo['productExpConfig'] = {
      event_id: exposureRecord.cms_TempoPage_HorizontalProductPool_expo,
      config: expConfig,
      json_param: json_param,
    };

    return eventTrackingInfo;
  };

  if (productList.length === 0) return;

  return (
    <div
      className={style.productList}
      style={{
        gap: adaptiveStyle.productListGap,
        paddingLeft: adaptiveStyle.productListPaddingLeft,
      }}
    >
      {productList.length
        ? productList.map((item: any, index: number) => {
            const productData = {
              type: ProductType.TYPE_1,
              width: adaptiveStyle.productCardWidth,
              jumpUrl: item?.jumpUrl ? item?.jumpUrl : null,
              skuName: item.skuName,
              shouldShowSkuName: true,
              skuId: item.skuId,
              realPrice: item.realPrice,
              originalPrice: item?.originalPriceV2,
              originalPriceTips: item?.originalPriceDesc,
              currency: localInfo?.currencyCode || '',
              languageCode: localInfo?.languageCode || '',
              cartChange: getCartNum,
              shouldShowCart: true,
              trackingPointParams: genEventTrackingInfo(item, index),
              // style
              containerStyle: {
                backgroundColor: '#fff',
              },
              skuImgKeyParams: {
                imgUrlKey: item?.imageUrl,
                width: 200,
                height: 200,
              },
              skuImgStyle: {
                width: adaptiveStyle.skuImgWidth,
                height: adaptiveStyle.skuImgHeight,
                borderRadius: '4px',
                alignSelf: 'center',
              },
              skuNameStyle: {
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical' as const,
                WebkitLineClamp: 2,
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
                height: '36px',
                marginTop: '-6px',
                overflow: 'hidden',
                color: '#1a1a1a',
                wordBreak: 'break-all' as const,
                paddingLeft: '8px',
                paddingRight: '8px',
              },
              priceStyle: {
                fontSize: '12px',
              },
              priceAndCartStyle: {
                paddingTop: '8px',
              },
              realPriceJDIPriceParams: {
                symbolStyle: { fontSize: '14px' },
                integerStyle: { fontSize: '18px' },
                decimalPointStyle: { fontSize: '18px' },
                decimalPlaceStyle: { fontSize: '18px' },
                containerStyle: {
                  display: 'block',
                  height: '20px',
                  lineHeight: '20px',
                  fontWeight: '700',
                  color: '#1a1a1a',
                  marginBottom: '2px',
                },
              },
              originalPriceJDIPriceParams: {
                containerStyle: {
                  height: '12px',
                  fontWeight: '500',
                  lineHeight: '12px',
                  color: '#888b94',
                },
              },
              cartIconColor: 'black',
              cartIconStyle: {
                width: adaptiveStyle.cartIconWidth,
                height: adaptiveStyle.cartIconHeight,
              },
            };
            return <ProductCard key={index} productData={productData} />;
          })
        : null}
    </div>
  );
};
